/** The server's `detail` sentence for a failed generated-client call, or a
 * status-specific/fallback sentence. Shared by the upload page and forms. */
export async function errorSentence(e: unknown, fallback: string): Promise<string> {
  if (e instanceof Error && e.name === 'ResponseError') {
    const response = (e as unknown as { response: Response }).response
    try {
      const body = await response.clone().json()
      if (typeof body?.detail === 'string') return body.detail
    } catch {
      // fall through to status-based message
    }
    if (response.status === 413) return 'That batch is too large — try fewer photos at once.'
    if (response.status === 429) return "You've hit today's upload limit — try again tomorrow."
    if (response.status === 503) return 'Uploads are paused right now — check back soon.'
  }
  return fallback
}
